import React from "react";
import { useSyncExternalStore } from "use-sync-external-store/shim";

if (!React.useSyncExternalStore) {
    React.useSyncExternalStore = useSyncExternalStore;
}
